import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Observable} from "rxjs/Observable";
import {
    FORM_DIRECTIVES,
    FORM_PROVIDERS,
    FormControl,
    FormGroup,
    REACTIVE_FORM_DIRECTIVES,
    Validators
} from "@angular/forms";
import {AlertComponent, TYPEAHEAD_DIRECTIVES} from "ng2-bootstrap/ng2-bootstrap";
import {VehiclesService} from "../service/vehicles.service";
import {ContractsService} from "../service/contracts.service";
import {BankService} from "../service/bank.service";
import {Vehicle} from "../domain/vehicle";
import {Bank} from "../domain/bank";
import {VehicleBrand} from "../domain/vehicleBrand";
import {
    AMOUNT_VALIDATOR,
    DATE_VALID_CHARACTERS,
    DATE_VALIDATOR,
    DEFAULT_ERROR_MESSAGES,
    PATENT_VALIDATOR_AUTO_PATTERN,
    PATENT_VALIDATOR_MOTO_PATTERN,
    YEAR_VALIDATOR
} from "../validators/validators";
import {LoginService} from "../service/login.service";
import {VehicleType} from "../domain/vehicleType";

@Component({
    selector: 'vehicle-editor',
    template: require('./vehicle.editor.component.html'),
    styles: [require('./vehicle.editor.component.css')],
    directives: [
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        /*MyDatePicker,*/
        TYPEAHEAD_DIRECTIVES
    ],
    providers: [FORM_PROVIDERS],
})
export class VehicleEditorComponent implements OnInit, OnDestroy, AfterViewInit {

    @Input() vehicle: Vehicle;
    @Output() close = new EventEmitter();

    private sub: any;

    public errorMessages: any;
    public form: FormGroup;

    public vehiclesType: VehicleType[];
    public vehiclesBrand: VehicleBrand[];
    public banks: Bank[];

    public createMode: boolean;

    public contractValid: boolean;
    public vehicleTypeId: string;

    private vehicleId: string;
    private contractId: string;

    public canEditContract: boolean = false;

    /*myDatePickerOptions:any;*/

    public errorMessage: string;
    public successMessage: string;

    public loading: boolean;

    public canEdit: boolean;

    public patentValid: boolean;

    constructor(private router: Router,
                private vehiclesService: VehiclesService,
                private contractsService: ContractsService,
                private bankService: BankService,
                private route: ActivatedRoute,
                private loginService: LoginService) {
        this.init();
    }

    private init(): void {
        this.errorMessages = DEFAULT_ERROR_MESSAGES;

        this.contractValid = false;

        this.loading = false;

        this.canEdit = false;

        this.patentValid = false;

        this.vehicle = new Vehicle();
        this.vehicle.contract.bank = new Bank();
    }

    private createFormGroup(): void {
        this.form = new FormGroup({
            patent: new FormControl(this.vehicle.patent, [Validators.required, this.validatePatentWithType.bind(this)]),
            type: new FormControl(this.vehicle.type.description, [Validators.required]),
            brand: new FormControl(this.vehicle.brand.name, [Validators.required]),
            /*version: new FormControl(this.vehicle.version),*/
            model: new FormControl(this.vehicle.model, [Validators.required]),
            year: new FormControl(this.vehicle.year, [YEAR_VALIDATOR]),
            engineNumber: new FormControl(this.vehicle.engineNumber),
            registrable: new FormControl(this.vehicle.registrable),
            center: new FormControl(this.vehicle.center),
            contractNumber: new FormControl(this.vehicle.contract.contractNumber, [Validators.required]),
            cuit: new FormControl(this.vehicle.contract.cuit),
            bank: new FormControl(this.vehicle.contract.bank.id, [Validators.required]),
            purchaseOrderEntryDate: new FormControl(this.vehicle.purchaseOrderAmount, [DATE_VALID_CHARACTERS, DATE_VALIDATOR]),
            purchaseOrderAmount: new FormControl(this.vehicle.purchaseOrderAmount, [AMOUNT_VALIDATOR]),
            purchaseOrderDueDate: new FormControl(this.vehicle.purchaseOrderDueDate, [DATE_VALID_CHARACTERS, DATE_VALIDATOR])
        });
    }

    private validatePatentWithType(c: FormControl): any {
        if (this.vehicle.type.description == 'MAQUINARIA') {
            return null;
        }
        let regexp = (this.vehicle.type.description == 'MOTO') ? new RegExp(PATENT_VALIDATOR_MOTO_PATTERN) : new RegExp(PATENT_VALIDATOR_AUTO_PATTERN);

        return regexp.test(c.value) ? null : {
            validatePatent: {
                valid: false
            }
        };
    }

    public ngOnInit() {
        let userLogged = this.loginService.getUserLogged();
        this.canEdit = userLogged.isActionAllowed('VEHICLES', 'EDIT', 'VEHICLES');

        /*this.myDatePickerOptions = {dateFormat: 'dd/mm/yyyy'};*/

        this.createFormGroup();

        this.sub = this.route.params.subscribe(params => {
            this.contractId = params['contractId'];
            this.canEditContract = params['contractEdit'] == 'true';
            let vehicleId = params['vehicleId'];
            if (vehicleId) {
                this.vehicleId = vehicleId;
                this.createMode = false;
            } else {
                this.createMode = true;
                this.canEditContract = true;
                this.vehicleId = null;
            }
            this.getData();
        });
    }

    public ngAfterViewInit() {
    }

    private getData(): void {
        this.loading = true;
        this.errorMessage = null;

        let forkTasks: Observable<any>[] = [];
        forkTasks.push(this.vehiclesService.getVehiclesType());
        forkTasks.push(this.vehiclesService.getVehiclesBrand());
        forkTasks.push(this.bankService.getBanks());
        if (this.vehicleId && this.contractId) {
            forkTasks.push(this.vehiclesService.getVehicle(this.contractId, this.vehicleId));
        } else if (this.contractId) {
            forkTasks.push(this.contractsService.getContract(this.contractId));
        }
        Observable.forkJoin(forkTasks).subscribe(
            this.setData.bind(this),
            () => {
                this.bindError('Ocurrió un error al obtener los datos del vehículo.')
            });
    }

    public setData(data: any[]): void {
        this.loading = false;
        this.vehiclesType = data[0];
        this.vehiclesBrand = data[1];
        this.banks = data[2];

        if (this.vehicleId) {
            this.vehicle = data[data.length - 1];
            this.contractValid = true;
            if (this.vehicle.type) {
                this.vehicleTypeId = this.vehicle.type.id;
            }
        } else {
            this.vehicle = new Vehicle();
            if (this.vehiclesType.length > 0) {
                /*Siempre en la opción "AUTO"*/
                this.vehicle.type = this.vehiclesType[1];
                this.vehicleTypeId = this.vehiclesType[1].id;
            }
            if (this.contractId) {
                this.vehicle.contract = data[data.length - 1];
            }
        }
        this.validatePatent();

        /*Si se va a crear un vehículo desde la pantalla Contrato:*/
        if (this.vehicleId == null && this.contractId) {
            this.canEditContract = false;
            this.contractValid = true;
        }
    }

    public ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private clearMessages(): void {
        this.successMessage = null;
        this.errorMessage = null;
    }

    private updateVehiclesBrand(vehicle: Vehicle): void {
        let result = this.vehiclesBrand.filter(
            function (obj: VehicleBrand) {
                return obj.name === vehicle.brand.name;
            });
        if (result.length == 0) {
            this.vehiclesBrand.push(vehicle.brand);
        }
    }

    public save(): void {
        this.clearMessages();
        this.loading = true;

        /*TODO: A la espera de si la columna "version" va a ser requerida*/
        this.vehicle.version = null;

        this.vehiclesService.save(this.vehicle).subscribe(
            (saved: Vehicle) => {
                this.loading = false;
                this.vehicle = saved;
                this.successMessage = 'El vehículo se guardó con éxito';
                this.updateVehiclesBrand(saved);
            },
            () => {
                this.bindError('Ocurrió un error al guardar la información.');
            });
    }

    public goBack(event: any): void {
        event.preventDefault();
        this.close.emit(this.vehicle);
        if (this.vehicleId == null && this.contractId == null) {
            window.history.back();
        } else if (this.vehicleId == null && this.contractId) {
            this.router.navigate(['app/home/editContract', this.contractId]);
        } else {
            window.history.back();
        }
    }

    public onBrandSelected(brand: any): void {
        this.vehicle.brand = brand.item;
    }

    /*onBankSelected(bank:Bank) {
     this.vehicle.contract.bank = bank;
     }

     setPurchaseOrderEntryDate(date:string) {
     this.vehicle.purchaseOrderEntryDate = date;
     }*/

    public enableContract(event: any): void {
        event.preventDefault();
        this.canEditContract = true;
    }

    public validatePatent(): void {
        this.vehiclesService.getVehicleByPatent(this.vehicle.patent).subscribe(
            (vehicle) => {
                if (vehicle && vehicle.id) {
                    this.patentValid = (this.vehicle.id == vehicle.id) ? true : false;
                } else {
                    this.patentValid = true;
                }
            },
            () => {
                this.patentValid = false;
                this.bindError('Ocurrió un error al validar patente de vehículo.');
            });
    }

    public validateContract(event: any): void {
        if (this.vehicle.contract.contractNumber && (event != null || this.vehicle.contract.bank.id)) {
            if (event != null) {
                this.vehicle.contract.bank = this.banks.find(bank => bank.id == event);
            }
            this.contractsService.getContractByContractNumberAndBank(this.vehicle.contract.contractNumber, this.vehicle.contract.bank.id).subscribe(
                (contract) => {
                    if (contract && contract.id) {
                        this.contractValid = (this.vehicle.contract.id == contract.id) ? true : false;
                    } else {
                        this.contractValid = true;
                    }
                },
                () => {
                    this.contractValid = false;
                    this.bindError('Ocurrió un error al validar contrato.');
                });
        }
    }

    public cleanPatent(newValue: any): void {
        this.vehicle.patent = "";
        let result = this.vehiclesType.filter(function (obj: VehicleType) {
            return obj.id == newValue;
        });
        if (result.length > 0) {
            this.vehicle.type = result[0];
        }
    }

    private bindError(messageError: string): void {
        this.loading = false;
        if (this.errorMessage == null) {
            this.errorMessage = messageError;
        } else {
            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/vehicles/vehicle.editor.component.ts
 **/